import { useSyncedParamValue } from "@/app/hooks/useSyncedParams";
import {
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Box,
} from "@chakra-ui/react";
import { Field, Form, FormLayout } from "@saas-ui/react";

export function NumberFieldFilter({
  label,
  field,
  isDisabled,
}: {
  field: string;
  label: string;
  isDisabled: boolean;
}) {
  const [localMax, setLocalMax] = useSyncedParamValue(`${field}__lte`);
  const [localMin, setLocalMin] = useSyncedParamValue(`${field}__gte`);
  const values = [localMin, localMax].filter((value) => value !== null);
  return (
    <>
      <AccordionButton>
        <Box as="span" flex="1" textAlign="left">
          {label}
          {!!values.length ? ` (${values.length})` : ""}
        </Box>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel>
        <Form onSubmit={() => {}}>
          <FormLayout columns={2}>
            <Field
              isDisabled={isDisabled}
              data-cy="min-input"
              name="min"
              label="Min"
              type="number"
              value={localMin || ""}
              onChange={setLocalMin}
            />
            <Field
              isDisabled={isDisabled}
              data-cy="max-input"
              name="max"
              label="Max"
              type="number"
              value={localMax || ""}
              onChange={setLocalMax}
            />
          </FormLayout>
        </Form>
      </AccordionPanel>
    </>
  );
}
